import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  relative 
  bg-charcoal 
  h-full 
  w-full
`);
